/** Cache tags for background jobs, their schedules and kinds (registered in apiSlice's tagTypes). */
export enum BackgroundJobTags {
  BackgroundJob = "BackgroundJob",
  BackgroundJobSchedule = "BackgroundJobSchedule",
  BackgroundJobKind = "BackgroundJobKind",
}
